module.exports = __webpack_public_path__ + "img/Filter_Line_16px_Icon-red.fbdee8f6.svg";